import { render, staticRenderFns } from "./ImportFromFileDetails.vue?vue&type=template&id=553b5021"
import script from "./ImportFromFileDetails.vue?vue&type=script&lang=js"
export * from "./ImportFromFileDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports